export enum ResourceType {
  TABLE = "Table",
  ROOM = "Room",
  VILLA = "Villa",
  HALL = "Hall",
}
